import { call, put, takeEvery, select } from "redux-saga/effects";
// import { AxiosDefaults } from "axios";
import { artists as actions } from "actions";
import { statuses, instance, artists } from "api";
import { SagaStates } from "Types";

function* searchArtists(action: any) {
   const { keyword = "" } = action.payload;

   const parameters = {
      keyword,
   };

   const status: string = yield select(function (state: SagaStates) {
      return state.artists.search.status;
   });
   console.log(status);
   if (status === statuses.pending) return;
   try {
      yield put({
         type: actions.search.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: SagaStates = yield call(instance.post, artists.search.uri, parameters);
      if ((response as any).result === "ok") {
         yield put({
            type: actions.search.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.search.fail,
            payload: response,
         });
      }
   } catch (error) {
      yield put({
         type: actions.search.fail,
         payload: error,
      });
   }
}

export function* artistsSaga() {
   yield takeEvery(actions.search.call, searchArtists);
}
